// Намерение выйти (control-plane флаг, §2.7). Отдельный модуль, чтобы и sync.saga, и
// user.saga делили его без импорта друг из друга. true с LOGOUT_INTENT до успешного
// login'а: пока активно, reconcile держит PAUSE(auth-required) без проб/резюма, а
// возврат сети НЕ возобновляет синк (пользователь сознательно вышел). Отличает
// logout от 401-истечения токена (то — просто !isAuth без intent).
let active = false;

export const setLogoutIntent = (): void => {
  active = true;
};

export const clearLogoutIntent = (): void => {
  active = false;
};

export const isLogoutIntentActive = (): boolean => active;
